import React from 'react';
import cn from 'classnames';
import { CTALink, IconButton } from "../../CTA";
import { ArrowLeftIcon, ArrowRightIcon, ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon, } from "../../Icon";
import { IconProps } from "../../Icon/types";
import styles from '../Carousel.module.scss';
import { ControlType } from '../constants';
const CarouselControl = ({ direction, onClick, className, label, arrowIconType, iconSizeNormal, disabled = false, arrowClassName, arrowIconClassName, variant, arrowBackground = 'default', arrowPosition = 'default', arrowBackgroundSize = 'default', labelControlClassName = '', }) => {
    const IconArrow = direction === 'next' ? ArrowRightIcon : ArrowLeftIcon;
    const IconVerticalChevron = direction === 'next' ? ChevronDownIcon : ChevronUpIcon;
    const IconHorizontalChevron = direction === 'next' ? ChevronRightIcon : ChevronLeftIcon;
    const getIconComp = () => {
        switch (arrowIconType) {
            case 'arrows-left-right': {
                return IconArrow;
            }
            case 'chevrons-up-down': {
                return IconVerticalChevron;
            }
            case 'chevrons-left-right': {
                return IconHorizontalChevron;
            }
            default:
                return IconArrow;
        }
    };
    const IconComp = getIconComp();
    const iconSize = arrowIconType !== 'arrows-left-right' || iconSizeNormal ? 'normal' : 'small';
    const arrowBackgroundClassName = arrowBackground === 'opaque' && styles.opaqueBackground;
    const arrowPositionClassName = arrowPosition === 'alignedToImage' && styles.alignedToImage;
    const arrowBackgroundSizeClassName = arrowBackgroundSize === 'small' && styles.smallBackground;
    return (React.createElement(React.Fragment, null, variant === ControlType.ARROW ? (React.createElement(IconButton, { onClick: onClick, className: cn(styles.arrow, iconSizeNormal && styles.iconSizeNormal, styles[direction], className, arrowClassName, arrowBackgroundClassName, arrowPositionClassName, arrowBackgroundSizeClassName), "aria-label": label, title: label, disabled: disabled, iconElement: React.createElement(IconComp, { "aria-hidden": true, className: cn(styles.arrowIcon, arrowIconClassName), size: iconSize }) }, label)) : (React.createElement(CTALink, { onClick: onClick, Tag: "button", className: cn(styles.arrow, styles[direction], styles.labelControl, className, labelControlClassName) }, label))));
};
export default CarouselControl;
//# sourceMappingURL=CarouselControl.js.map